export default "__VITE_ASSET__BcguZqYz__"